import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { SnapshotFileStatus } from '@data/interfaces/verification-snapshot.interface'

/**
 * «Ver PDF» de la foto de Syntage (F-158): botón de solo ícono en el encabezado de Buró, en el de BIL y en la casilla
 * 32-D. Abre el previsualizador; quien lo pinta decide si se ofrece (`SnapshotFiles.offers`) y pone la nota del estado.
 *
 * Estados: copiado abre · `opening` deshabilitado con spinner y «Abriendo …» · cualquier otro estado, deshabilitado.
 */
@Component({
  selector: 'app-snapshot-pdf-button',
  templateUrl: './snapshot-pdf-button.component.html',
  styleUrls: ['./snapshot-pdf-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnapshotPdfButtonComponent {
  @Input() status: SnapshotFileStatus | null = null
  /** El PDF se está pidiendo: el botón queda deshabilitado, con spinner y «Abriendo …». */
  @Input() opening = false
  /** Qué PDF es, con su artículo: «el reporte BIL». Arma el tooltip y el nombre accesible. */
  @Input() subject = ''
  @Output() open = new EventEmitter<void>()

  get disabled(): boolean {
    return this.status !== 'copied' || this.opening
  }

  /** Lo que dice el tooltip y el `aria-label` en reposo: «Ver o descargar en PDF el reporte BIL». */
  get label(): string {
    return `Ver o descargar en PDF ${this.subject}`
  }

  /** Nombre accesible: mientras se pide el PDF, «Abriendo el reporte BIL…». */
  get ariaLabel(): string {
    return this.opening ? `Abriendo ${this.subject}…` : this.label
  }
}
